<section class="bluesage-terminal-picker" *ngIf="viewModel$ | async as viewModel">

    <div class="p-d-flex p-ai-center p-jc-between p-mb-2">
        <span class="p-input-icon-left p-mr-2 terminal-search">
            <i class="pi pi-search"></i>
            <!-- Filters from the first character. The whole roster is already
                 here, so there is nothing to wait for and no Enter key. -->
            <input
                pInputText
                type="text"
                class="p-inputtext-sm terminal-search"
                placeholder="Search by last digits, e.g. 7943"
                [ngModel]="viewModel.search"
                (ngModelChange)="store.dispatch(actions.searchChanged({ search: $event }))"
            />
        </span>

        <p-button
            icon="pi pi-refresh"
            [text]="true"
            size="small"
            pTooltip="Check the terminals again"
            tooltipPosition="left"
            [loading]="viewModel.loading"
            (onClick)="store.dispatch(actions.refreshButtonClicked())"
        ></p-button>
    </div>

    <!-- Requirement: status is rendered as "last checked HH:MM" rather than as
         live truth. The roster is live when the picker opens and a minute old by
         the time Send is pressed; the middleware's check at push time is the
         authority, so nothing here should imply otherwise. -->
    <p class="p-text-secondary p-mb-2 terminal-hint" *ngIf="viewModel.rosterIsCached">
        <i class="pi pi-exclamation-triangle p-mr-1"></i>
        Could not reach the device-status service, so these are the last known
        readings<span *ngIf="viewModel.checkedAt"> (checked {{ viewModel.checkedAt | date: 'HH:mm' }})</span>.
        You can still send to any of them.
    </p>

    <p class="p-text-secondary p-mb-2 terminal-hint" *ngIf="viewModel.loading">
        Checking which terminals are online…
    </p>

    <!-- A FAILED load and an EMPTY location are different answers and get
         different messages. Rendering a failure as "no terminals" tells an
         operator this location has no devices, which is a lie. -->
    <p class="p-error p-mb-2" *ngIf="viewModel.loadFailed">
        Could not load the terminals.
        <a href="javascript:void(0)" (click)="store.dispatch(actions.refreshButtonClicked())">Try again</a>.
    </p>

    <p class="p-text-secondary" *ngIf="viewModel.showEmptyState">
        No terminals are registered to this location yet.
    </p>

    <p class="p-text-secondary" *ngIf="viewModel.showNoMatches">
        No terminal matches “{{ viewModel.search }}”.
    </p>

    <ul class="bluesage-terminal-list p-p-0 p-m-0">
        <li *ngFor="let row of viewModel.rows">
            <button
                type="button"
                class="terminal-row p-d-flex p-ai-center p-jc-between p-p-2 p-mb-1"
                [class.dimmed]="row.dimmed && !row.busy"
                [class.selected]="row.selected"
                [class.busy]="row.busy"
                [disabled]="row.busy"
                [pTooltip]="row.busyLabel"
                tooltipPosition="top"
                (click)="store.dispatch(actions.terminalSelected({ epi: row.epi }))"
            >
                <span class="p-d-flex p-flex-column">
                    <span class="terminal-epi">{{ row.masked }}</span>
                    <small class="p-text-secondary" *ngIf="row.recent">Recently used by you</small>
                </span>

                <span class="p-d-flex p-ai-center">
                    <!-- Busy outranks status: the operator needs to know the device
                         is taken before they care whether it is online. -->
                    <small *ngIf="row.busy" class="p-text-secondary">{{ row.busyLabel }}</small>

                    <ng-container *ngIf="!row.busy">
                        <i
                            class="pi p-mr-1"
                            [class.pi-circle-fill]="row.status === 'online'"
                            [class.pi-circle]="row.status === 'offline'"
                            [class.pi-question-circle]="row.status !== 'online' && row.status !== 'offline'"
                            [style.color]="row.status === 'online' ? 'var(--green-500)' : 'var(--text-color-secondary)'"
                        ></i>
                        <small class="p-text-secondary">{{ row.statusLabel }}</small>
                    </ng-container>
                </span>
            </button>
        </li>
    </ul>

    <!-- ⚠ A busy location has thirty terminals and this picker lives inside a
         payment dialog. Showing them all pushes the amount, the method and the
         Send button off the tablet the payment is being taken on, so the roster
         is a shortlist by default — the ordering already puts the device this
         operator last used first. A search bypasses this entirely. -->
    <p-button
        class="p-mt-1"
        *ngIf="viewModel.hiddenCount"
        [label]="'Show ' + viewModel.hiddenCount + ' more terminal' + (viewModel.hiddenCount === 1 ? '' : 's')"
        icon="pi pi-chevron-down"
        severity="secondary"
        size="small"
        [text]="true"
        (onClick)="store.dispatch(actions.showAllTerminalsButtonClicked())"
    ></p-button>

    <p-button
        class="p-mt-1"
        *ngIf="viewModel.expanded && !viewModel.hiddenCount && viewModel.rows.length > 2"
        label="Show fewer"
        icon="pi pi-chevron-up"
        severity="secondary"
        size="small"
        [text]="true"
        (onClick)="store.dispatch(actions.showFewerTerminalsButtonClicked())"
    ></p-button>
</section>
